import { render, staticRenderFns } from "./PropertyTab.vue?vue&type=template&id=498ac443&scoped=true"
import script from "./PropertyTab.vue?vue&type=script&lang=js"
export * from "./PropertyTab.vue?vue&type=script&lang=js"
import style0 from "./PropertyTab.vue?vue&type=style&index=0&id=498ac443&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498ac443",
  null
  
)

export default component.exports